import React, { useEffect, useState } from "react";
import "../../styles/Notices.css";

function Notices() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL;

    fetch(`${API_URL}/api/notices`)
      .then(async (res) => {
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          return Array.isArray(json) ? json : [];
        } catch {
          console.error("❌ API did not return JSON");
          return [];
        }
      })
      .then((data) => {
        setNotices(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Fetch error:", err);
        setLoading(false);
      });
  }, []);

  const latestNotice = notices.length > 0 ? notices[0] : null;

  return (
    <section className="notices-section">
      {/* Highlight Bar */}
      <div className="highlight-bar" role="status" aria-live="polite">
        <span className="blink-dot" aria-hidden="true"></span>
        {loading ? (
          <p>Loading latest update…</p>
        ) : latestNotice ? (
          <p>
            <strong>Important:</strong> {latestNotice.title} –{" "}
            {latestNotice.message.slice(0, 80)}…
          </p>
        ) : (
          <p>No recent important updates.</p>
        )}
      </div>

      <h2 className="notices-title">📢 Notices & Announcements</h2>

      {loading ? (
        <div className="notices-container">
          {[1, 2, 3].map((i) => (
            <div key={i} className="notice-skeleton" />
          ))}
        </div>
      ) : notices.length === 0 ? (
        <p className="no-notice">No notices available at the moment.</p>
      ) : (
        <div className="notices-container">
          {notices.map((notice) => (
            <div key={notice._id} className="notice-card">
              <div className="notice-header">
                <h3>{notice.title}</h3>
                <span className="category">{notice.category}</span>
              </div>

              <p className="notice-message">{notice.message}</p>

              <div className="notice-footer">
                <span className="date">
                  {new Date(notice.date).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default Notices;
